var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nedom"},[_c('div',{ref:"wrap",staticClass:"Chartleftok",staticStyle:{"height":"350px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }